import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "account",
  "use": "account-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"account\"><path d=\"M20 20c5.43 0 9.848 4.327 9.996 9.72L30 30h-2a8 8 0 00-15.996-.25L12 30h-2c0-5.523 4.477-10 10-10z\" /><path d=\"M20 9a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm0 2a4.5 4.5 0 110 9 4.5 4.5 0 010-9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol